module.exports = __webpack_public_path__ + "media/images/pic/teachers/julia-caba-486e22d64c96156f9e606929358174df.webp";